import React, { useEffect } from 'react';

import { logoutAPI } from '../../common/api';
import { getRedirect } from '../../common/util/server-util';

function Logout() {
  useEffect(() => {
    logoutAPI.logout()
      .then(() => {
        window.location = getRedirect();
      })
      .catch(() => {
      });
  }, []);

  return (
    <>
    </>
  );
}

export default Logout;
